import FilterIcon from "../../../../components/icons/Filter";
import Text from "antd/lib/typography/Text";
import React, { useCallback, useEffect, useState } from "react";
import {
  VuiButton,
  VuiCheckbox,
  VuiSecondaryTitleWrapper,
} from "../../../../@vendor/components";
import { CloseIcon } from "../../../../components";
import { Col, Modal, Row } from "antd";
import { useDisclosure } from "../../../../hooks/use-disclosure";
import { useTranslation } from "react-i18next";
import { Expertise } from "../../../../models/Expertise";

interface IFilterExpertise {
  expertises: Expertise[];
  selectedData?: number[];
  onChange?: (expertises: number[]) => void;
}

const FilterExpertise = ({
  expertises,
  selectedData,
  onChange,
}: IFilterExpertise) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation();
  const [currExpertises, setCurrExpertises] = useState<number[]>([]);

  const onChangeExpertise = useCallback(
    (value: boolean, expertiseId: number) => {
      setCurrExpertises((prevState) => {
        let cloneState: number[] = [...prevState];
        if (value) {
          cloneState.push(expertiseId);
        } else {
          cloneState = cloneState.filter((e) => e !== expertiseId);
        }
        return cloneState;
      });
    },
    []
  );

  const handleApply = () => {
    if (onChange) onChange(currExpertises);
    onClose();
  };

  useEffect(() => {
    if (isOpen && selectedData?.length) {
      setCurrExpertises(selectedData);
    }
  }, [selectedData, isOpen]);

  return (
    <>
      <Modal
        footer={null}
        closable={false}
        visible={isOpen}
        className="default-modal"
        title={null}
        centered
      >
        <div className="default-modal-header">
          <VuiSecondaryTitleWrapper
            title={t("common.text.filterExpertises")}
            level={4}
          >
            <CloseIcon onClick={onClose} />
          </VuiSecondaryTitleWrapper>
        </div>

        <div>
          {expertises.map((expertise, index) => (
            <VuiCheckbox
              style={{ marginLeft: 0 }}
              key={`expertise_${index}`}
              value={expertise.id}
              title={expertise.name}
              checked={currExpertises?.includes(expertise.id)}
              onChange={(e) => {
                onChangeExpertise(e.target.checked, expertise.id);
              }}
            />
          ))}
        </div>

        <Row gutter={[12, 12]}>
          <Col md={24} xs={24}>
            <VuiButton
              buttonProps={{ type: "primary", onClick: handleApply }}
              label={t("common.button.apply")}
            />
          </Col>
        </Row>
      </Modal>

      <div className="filter-expertise-mobile" onClick={onOpen}>
        <FilterIcon />
        <Text>Filter</Text>
      </div>
    </>
  );
};

export default FilterExpertise;
